import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon, ChipsSelect } from 'components/common/Elements/Elements';

import classes from './BtnPurple32.module.scss';

const BtnPurple32 = ({
  textButton,
  onClick,
  className,
  type = 'button',
  recentData,
  isChecked,
  onCreate,
  mixpanel
}) => {
  const [windowVisible, setWindowVisible] = useState(false);

  const node = useRef();
  const buttonList = useRef();

  useEffect(() => {
    if (windowVisible) {
      document.addEventListener('mousedown', handleClick);
      document.addEventListener('keydown', escAndTabFunction);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', escAndTabFunction);
    };
  }, [windowVisible]);

  const escAndTabFunction = event => {
    if (event.code === 'Escape' || event.code === 'Tab') {
      setWindowVisible(false);
    }
  };

  const handleClick = e => {
    if (
      node.current.contains(e.target) ||
      buttonList.current.contains(e.target)
    ) {
      return;
    }
    setWindowVisible(false);
  };

  const hahdleButton = () => {
    setWindowVisible(!windowVisible);
  };

  return (
    <div ref={buttonList} className={classes.container}>
      <button
        type={type}
        onClick={hahdleButton}
        className={cn(classes.btnPurple32, className)}
      >
        <p>{textButton}</p>
        <Icon icon={'Icn_Arrow'} className={classes.icon} />
      </button>

      {windowVisible && (
        <div
          className={cn(classes.windowWrap, classes.windowWrap_center)}
          ref={node}
          onClick={() => setWindowVisible(false)}
        >
          <ChipsSelect
            onClickAll={onClick}
            dataChipsSelect={recentData}
            isChecked={isChecked}
            onCreate={onCreate}
            mixpanel={mixpanel}
          />
        </div>
      )}
    </div>
  );
};

BtnPurple32.propTypes = {
  textButton: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  recentData: PropTypes.array,
  isChecked: PropTypes.string,
  onCreate: PropTypes.func,
  mixpanel: PropTypes.object
};

export default BtnPurple32;
